import { FC } from 'react';
import { Box, styled } from '@mui/material';
import { STATUS_COLORS, StatusColorType } from '@utils/constants/color';

interface StatusTagProps {
  type: StatusColorType;
  label: string;
  size?: 'small' | 'medium' | 'large';
}

interface StyledTagProps {
  colorType: StatusColorType;
  size: 'small' | 'medium' | 'large';
}

const StyledTag = styled(Box)<StyledTagProps>(({ colorType, size }) => {
  const colors = STATUS_COLORS[colorType];
  const padding =
    size === 'small' ? '2px 8px' : size === 'medium' ? '4px 12px' : '6px 16px';
  const fontSize =
    size === 'small' ? '12px' : size === 'medium' ? '14px' : '16px';

  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding,
    fontSize,
    fontWeight: 500,
    borderRadius: '4px',
    backgroundColor: colors.background,
    color: colors.text,
    border: `1px solid ${colors.border}`,
    whiteSpace: 'nowrap',
  };
});

const StatusTag: FC<StatusTagProps> = ({ type, label, size = 'medium' }) => {
  return (
    <StyledTag colorType={type} size={size}>
      {label}
    </StyledTag>
  );
};

export default StatusTag;
